import { render, staticRenderFns } from "./SsoLoginError.vue?vue&type=template&id=13e16801"
import script from "./SsoLoginError.vue?vue&type=script&lang=ts"
export * from "./SsoLoginError.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports